import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowsPage.WorkflowListItem', {
    activated: 'Activated',
    notActivated: 'Not activated',
    unnamed: 'Unnamed workflow',
});
